import getLocalString from "constants/Localization";
import { useCustomUpdateProposalStageAddressAndClearProductsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateProposalStageAddressAndClearProducts() {
  const [mutation, { loading, data, error }] =
    useCustomUpdateProposalStageAddressAndClearProductsMutation({
      refetchQueries: ["getProposal", "customGetProposals"],
    });

  const [updateProposalStageAddressAndClearProducts, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "updateProposalStageAddressAndClearProducts",
    },
    {
      successMessage: getLocalString("proposals.update-stage-address-success"),
      failureMessage: getLocalString("proposals.update-stage-address-failure"),
      showValidationErrors: true,
    }
  );

  return [updateProposalStageAddressAndClearProducts, context] as const;
}
